export default "__VITE_ASSET__CNmBFrSZ__"